import { Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const TabPanel3 = ({ data }: any) => {
  const { t } = useTranslation(["operation"]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="jatoBatteryAmps"
          name="jatoBatteryAmps"
          label={t("vehicle.tabPanel3.jatoBatteryAmps")}
          value={data.jatoBatteryAmps}
        />
        <TextField
          fullWidth
          disabled
          id="jatoBatteryLifeExpecta"
          name="jatoBatteryLifeExpecta"
          label={t("vehicle.tabPanel3.jatoBatteryLifeExpecta")}
          value={data.jatoBatteryLifeExpecta}
        />
        <TextField
          fullWidth
          disabled
          id="jatoBatteryTypeCode"
          name="jatoBatteryTypeCode"
          label={t("vehicle.tabPanel3.jatoBatteryTypeCode")}
          value={data.jatoBatteryTypeCode}
        />
        <TextField
          fullWidth
          disabled
          id="jatoBatteryTypeDescr"
          name="jatoBatteryTypeDescr"
          label={t("vehicle.tabPanel3.jatoBatteryTypeDescr")}
          value={data.jatoBatteryTypeDescr}
        />
        <TextField
          fullWidth
          disabled
          id="jatoBatteryVoltage"
          name="jatoBatteryVoltage"
          label={t("vehicle.tabPanel3.jatoBatteryVoltage")}
          value={data.jatoBatteryVoltage}
        />
        <TextField
          fullWidth
          disabled
          id="jatoChargingCableIncludedCode"
          name="jatoChargingCableIncludedCode"
          label={t("vehicle.tabPanel3.jatoChargingCableIncludedCode")}
          value={data.jatoChargingCableIncludedCode}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="jatoChargingConnectorCode"
          name="jatoChargingConnectorCode"
          label={t("vehicle.tabPanel3.jatoChargingConnectorCode")}
          value={data.jatoChargingConnectorCode}
        />
        <TextField
          fullWidth
          disabled
          id="jatoChargingConnectorDescr"
          name="jatoChargingConnectorDescr"
          label={t("vehicle.tabPanel3.jatoChargingConnectorDescr")}
          value={data.jatoChargingConnectorDescr}
        />

        <TextField
          fullWidth
          disabled
          id="jatoWarrantyBatteryCode"
          name="jatoWarrantyBatteryCode"
          label={t("vehicle.tabPanel3.jatoWarrantyBatteryCode")}
          value={data.jatoWarrantyBatteryCode}
        />
        <TextField
          fullWidth
          disabled
          id="jatoWarrantyBatteryDescr"
          name="jatoWarrantyBatteryDescr"
          label={t("vehicle.tabPanel3.jatoWarrantyBatteryDescr")}
          value={data.jatoWarrantyBatteryDescr}
        />
        <TextField
          fullWidth
          disabled
          id="jatoDuration"
          name="jatoDuration"
          label={t("vehicle.tabPanel3.jatoDuration")}
          value={data.jatoDuration}
        />
        <TextField
          fullWidth
          disabled
          id="jatoChargingCableIncludedDescr"
          name="jatoChargingCableIncludedDescr"
          label={t("vehicle.tabPanel3.jatoChargingCableIncludedDescr")}
          value={data.jatoChargingCableIncludedDescr}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="jatoChargingInfoCode"
          name="jatoChargingInfoCode"
          label={t("vehicle.tabPanel3.jatoChargingInfoCode")}
          value={data.jatoChargingInfoCode}
        />
        <TextField
          fullWidth
          disabled
          id="jatoChargingInfoDescr"
          name="jatoChargingInfoDescr"
          label={t("vehicle.tabPanel3.jatoChargingInfoDescr")}
          value={data.jatoChargingInfoDescr}
        />
        <TextField
          fullWidth
          disabled
          id="jatoRangeKm"
          name="jatoRangeKm"
          label={t("vehicle.tabPanel3.jatoRangeKm")}
          value={data.jatoRangeKm}
        />
        <TextField
          fullWidth
          disabled
          id="kmContract"
          name="kmContract"
          label={t("vehicle.tabPanel3.kmContract")}
          value={data.kmContract}
        />
        <TextField
          fullWidth
          disabled
          id="principalTireLoadCapacity"
          name="principalTireLoadCapacity"
          label={t("vehicle.tabPanel3.principalTireLoadCapacity")}
          value={data.principalTireLoadCapacity}
        />
        <TextField
          fullWidth
          disabled
          id="principalTireSpeed"
          name="principalTireSpeed"
          label={t("vehicle.tabPanel3.principalTireSpeed")}
          value={data.principalTireSpeed}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="powertrainTypeCode"
          name="powertrainTypeCode"
          label={t("vehicle.tabPanel3.powertrainTypeCode")}
          value={data.powertrainTypeCode}
        />
        <TextField
          fullWidth
          disabled
          id="powertrainTypeDescr"
          name="powertrainTypeDescr"
          label={t("vehicle.tabPanel3.powertrainTypeDescr")}
          value={data.powertrainTypeDescr}
        />
        <TextField
          fullWidth
          disabled
          id="mixedConsumption"
          name="mixedConsumption"
          label={t("vehicle.tabPanel3.mixedConsumption")}
          value={data.mixedConsumption.toFixed(1)}
        />

        <TextField
          fullWidth
          disabled
          id="rechargeStandardTime"
          name="rechargeStandardTime"
          label={t("vehicle.tabPanel3.rechargeStandardTime")}
          value={data.rechargeStandardTime.replace(",", ".")}
        />
        <TextField
          fullWidth
          disabled
          id="oldPlate"
          name="oldPlate"
          label={t("vehicle.tabPanel3.oldPlate")}
          value={data.oldPlate}
        />
        <TextField
          fullWidth
          disabled
          id="oldVin"
          name="oldVin"
          label={t("vehicle.tabPanel3.oldVin")}
          value={data.oldVin}
        />
      </Grid>
    </Grid>
  );
};
export default TabPanel3;
